import { useGetTasksQuery } from 'redux-stores/tasks/tasksApi';

export type TasksFilter = 'active' | 'completed';

type UseFilterTasksProps = {
  filter: TasksFilter;
  orgId?: string;
  skip: boolean;
};
const useFilterTasks = ({ filter, orgId, skip }: UseFilterTasksProps) => {
  const apiFilter = filter === 'active' ? 'open' : 'completed';
  const { data: tasks = [], isLoading } = useGetTasksQuery(
    { organizationId: orgId ?? '', filter: apiFilter },
    { skip }
  );
  return { tasks: isLoading ? [] : tasks, isLoading };
};

export default useFilterTasks;
